import React from 'react'
import classnames from 'classnames'
import '@/assets/styles/components/Input.scss'
import { dataType } from '@/constants/data-type';
import { formatFunctions, Validators } from '../../helpers/functions';
import { settingConfigs } from '@/configurations';

class Input extends React.Component {
  constructor(props) {
    super(props)
    props.innerRef(this);
    this.state = {
      count: 0,
      countBefore: -1,
      countAfter: 1,
      isAfter: false,
      isBefore: false,
      isWarn: false,
      isHover:false,
      isFocus:false
    }
  }

  subtract = () => {
    const { priceMode, step, minusStep } = this.props;
    const spread = priceMode ? minusStep : step;
    let countNumber = (this.state.count + '').replaceAll(settingConfigs.PRICE.thousandSeparator, '')
    let count = countNumber * 1000 - spread * 1000
    count = count / 1000
    if (count < 0) {
      return
    }
    if (this.props.dataType === dataType.CURRENCY) {
      count = formatFunctions.dataFormat(count, dataType.CURRENCY)
    } else if (this.props.dataType === dataType.NUMBER) {
      count = formatFunctions.dataFormat(count, dataType.NUMBER)
    }
    this.setState({
      isBefore: true,
    })
    setTimeout(() => {
      this.setState({
        count: count,
        countBefore: (count * 1000 - spread * 1000) / 1000,
        countAfter: (count * 1000 + spread * 1000) / 1000,
        isBefore: false,
        isWarn: false,
      }, () => {
        this.props.onChange((this.state.count + '').replaceAll(settingConfigs.PRICE.thousandSeparator, ''))
      })
    }, 200)
  }

  add = () => {
    this.setState({
      isAfter: true,
    })
    setTimeout(() => {
      const { priceMode, step, plusStep } = this.props;
      const spread = priceMode ? plusStep : step;
      let countNumber =(this.state.count + '').replaceAll(settingConfigs.PRICE.thousandSeparator, '');
      let count = +(countNumber * 1000) + spread * 1000
      count = count / 1000;
      let countBefore = (count * 1000 - spread * 1000) / 1000;
      let countAfter = (count * 1000 + spread * 1000) / 1000;
      if (this.props.dataType === dataType.CURRENCY) {
        count = formatFunctions.dataFormat(count, dataType.CURRENCY)
        countBefore = formatFunctions.dataFormat(countBefore, dataType.CURRENCY)
        countAfter = formatFunctions.dataFormat(countAfter, dataType.CURRENCY)
      } else if (this.props.dataType === dataType.NUMBER) {
        count = formatFunctions.dataFormat(count, dataType.NUMBER)
        countBefore = formatFunctions.dataFormat(countBefore, dataType.NUMBER)
        countAfter = formatFunctions.dataFormat(countAfter, dataType.NUMBER)
      }
      this.setState({
        count,
        countBefore,
        countAfter,
        isAfter: false,
        isWarn: false,
      }, () => {
        this.props.onChange((this.state.count + '').replaceAll(settingConfigs.PRICE.thousandSeparator, ''))
      })
    }, 200)
  }

  modify = e => {
    let count = e.target.value
    let isFloat = count.includes('.')
    if (isFloat) {
      let numReg = /^\d+\.\d+$/
      if (!numReg.test(count)) {
        this.setState({
          isWarn: true,
        })
        return
      } else {
        this.setState({
          isWarn: false,
        })
      }
    } else {
      this.setState({
        isWarn: false,
      })
    }
    this.setState({
      count: count,
    })
    this.props.onChange(this.state.count)
  }

  inputValue = e => {
    let count = e.target.value;
    count = count.replaceAll(settingConfigs.PRICE.thousandSeparator, '').replaceAll(settingConfigs.PRICE.minusSign,'');
    let isValid = false;
    if (count) {
      if (this.props.dataType === dataType.CURRENCY && Validators.currency(count, settingConfigs.PRICE.decimalSeparator, settingConfigs.PRICE.decimal)) {
        isValid = true;
      } else if (this.props.dataType === dataType.NUMBER && Validators.positiveIntegerNumber(count)) {
        isValid = true;
      }
    } else {
      isValid = true;
    }
    if (isValid) {
      this.setState({ count })
      this.props.onChange(count)
    }
  }

  setValue(count) {
    this.formatNumber(count, false);
  }

  getValue() {
    let value = this.state.count + '';
    return value.replaceAll(settingConfigs.PRICE.thousandSeparator, '')
  }

  formatNumber = (value, isWarning = true) => {
    let number = `${value}`.replaceAll(settingConfigs.PRICE.thousandSeparator, '');
    if (number) {
      number = parseFloat(number);
    } else {
      number = 0;
    }
    const isWarn = !number;
    if (this.props.dataType === dataType.CURRENCY) {
      number = formatFunctions.dataFormat(number, dataType.CURRENCY)
    } else if (this.props.dataType === dataType.NUMBER) {
      number = formatFunctions.dataFormat(number, dataType.NUMBER)
    }
    this.setState({ count: number })
    if(isWarning) {
      this.setState({ isWarn })
    }
  }

  handleKeyPress = e => {
    if (e.keyCode === 9 || e.keyCode === 13) {
      e.preventDefault();
      const eData = {
        keyCode: e.keyCode,
        prevKey: this.props.prevKey,
        currentKey: this.props.currentKey,
        nextKey: this.props.nextKey
      };
      this.props.onKeyPress(eData);
    }
  }

  focusInput = () => {
    this.inputRef.focus();
  }

  borderchange=()=>{
    const {isWarn , isFocus} =this.state
    if(!isWarn){
      this.setState({isFocus : true , isWarn:false , isHover:false})
    }
  }

  render() {
    const { isBefore, isAfter, countBefore, countAfter, count, isWarn , isHover , isFocus} = this.state
    const { style, priceMode } = this.props;
    return (
      <div style={style} className={classnames(isWarn ? 'warn' : '', 'c-input' , isHover ? 'hover' : '' , isFocus ? 'focus' : '')}>
        <button className={classnames('c-ipt-button')} onClick={() => this.subtract()} style={((count === 0)&&priceMode)? {display:'none'} : {display:'block'}}>-</button>
        <span className={classnames('c-ipt-span', isBefore ? 'before' : '', isAfter ? 'after' : '')} data-before={countBefore} data-after={countAfter}>
          <input className="c-ipt"
            ref={inputEl => (this.inputRef = inputEl)}
            type='text'
            value={count === 0 ? settingConfigs.PRICE.minusSign : count}
            // onBlur={e => this.modify(e)}g
            onMouseLeave={()=>this.setState({isHover:false})}
            onFocus={() => this.borderchange}
            onMouseEnter ={() => this.setState({isHover : true})}
            onBlur={e => this.formatNumber(e.target.value)}
            onChange={e => this.inputValue(e)}
            onKeyDown={e => this.handleKeyPress(e)}
          />
        </span>
        <button className={classnames('c-ipt-button')} onClick={() => this.add()} style={((count === 0)&&priceMode)? {display:'none'} : {display:'block'}}>+</button>
      </div>
    )
  }
}

Input.defaultProps = {
  step: 0.1,
  onChange: () => { },
  innerRef: () => { },
  priceMode: false,
  minusStep: 0.1,
  plusStep: 0.1,
  dataType: dataType.CURRENCY,
  onKeyPress: () => { },
  prevKey: '',
  currentKey: '',
  nextKey: ''
}

export default Input
